import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { AssetPerformanceDetailModel } from '../../../Models/Models/PortfolioAnalysis/Performance/AssetPerformanceDetailModel';
import { IJsonDate } from '../../../System/IJsonDate';
import { PerformanceMethod } from '../../../Constants/Enums/Domain/PerformanceMethod';
import { AssetClassType } from '../../../Constants/Enums/Domain/Instrument/AssetClassType';
import { ViewType } from '../../../Mapping/PortfolioAnalysis/Investment/Enum/ViewType';

declare var IS_RUNNING_IN_APP_POOL;

export class ModelPortfolioPerformanceDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(fromDateTime: IJsonDate, toDateTime: IJsonDate, performanceMethod: PerformanceMethod, assetClassType: AssetClassType, modelIds: Array<number>, viewType: ViewType): Promise<Array<AssetPerformanceDetailModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Performance/ModelPortfolioPerformanceDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { fromDateTime: fromDateTime, toDateTime: toDateTime, performanceMethod: performanceMethod, assetClassType: assetClassType, modelIds: modelIds, viewType: viewType }

    return AjaxWrapper.get<Array<AssetPerformanceDetailModel>, any>(url, data);
  }
}

